export default __webpack_public_path__ + "static/O0091-8104de6ba0c8dd49cdad319f0606dd80.png";